import React from 'react'
import "./landingNew.min.css"
import "./responsive-landingNew.min.css"
import dateUtil from "date-and-time";
import HeaderLanding from "./Header"
import BypassHeader from '../BypassHeader'
import Footer from "./Footer"
import {authService} from '../auth';
import Home from '../Home';
import {Link, NavLink} from "react-router-dom";
import $ from 'jquery';
import {LazyLoadImage} from "react-lazy-load-image-component";
import axios from 'axios'
import * as _ from "lodash";
import {convertUnicode, getCDNUrl, getVolunterProjectName, isWebView, postMsg, redirectToProfilePage} from "../commons/CommonFunctions";
import mappingUtils from "../project/component/commons/utils/mappingUtils";
import Linkify from "react-linkify";
import AuthModalComponent from "../LoginExtra/AuthModalComponent";
import SignUpModal from "../SignUpModal/signUpModal";
import {renderToString} from "react-dom/server";
import LeftPanelUnauth from "../commons/LeftPanelUnauth";
import { Link as Link1 } from "react-scroll";
import ReactPlayer from 'react-player/lazy';
import BelongHereSection from './BelongHereSection';
import InspiringStorySection from './InspiringStorySection';
import WeNatSolutionsSection from './WeNatSolutionsSection';
import TrendingContentSection from './TrendingContentSection';
import TestimonialItem from './TestimonialItems';

const nFormatter = (num, digits) => {
    if (!num) {
        return num
    }
    var si = [
        {value: 1, symbol: ""},
        {value: 1E3, symbol: "k"},
        {value: 1E6, symbol: "M"},
        {value: 1E9, symbol: "G"},
        {value: 1E12, symbol: "T"},
        {value: 1E15, symbol: "P"},
        {value: 1E18, symbol: "E"}
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;
    for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
            break;
        }
    }
    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}

class Landing extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isStopped: false,
            isPaused: false,
            loginSuccess: authService.isAuthenticated(),
            isModalOpen: false,
            projectId: undefined,
            loginRequired:false,
            signUpRequired:false,
            projectDetail: {},
            slug: '',
            promotionData: [],
            testimonials: {flag: true, count: 0} 
        };
    }

    componentDidMount() {
        document.title = 'Explore a new world of Naturalists | WeNaturalists';
        $('.bk_mobMenuOpn').click(function () {
            $('.bk_mobNavBx').addClass("mMactive");
            $('body').addClass('moBmnuopen');
            $(this).css("opacity", "0");
        });
        $('.bk_mobMenu_clse').click(function () {
            $('.bk_mobNavBx').removeClass("mMactive");
            $('body').removeClass('moBmnuopen');
            $('.bk_mobMenuOpn').css("opacity", "1");
        });
        $('.bk_mobmnulst_cntbx ul li a').click(function () {
            $('body').removeClass('moBmnuopen');
        });
        $('.bk_ban_btns .btn.signup').click(function () {
            $('body').removeClass('moBmnuopen');
        });
        $('.bk_ban_btns .btn.login').click(function () {
            $('body').removeClass('moBmnuopen');
        });
        window.$(".extChatContainer")
            .stop()
            .animate({ scrollTop: window.$(".extChatContainer")[0].scrollHeight, }, 300);   
        $(window).scroll(function () {

            if ($(window).scrollTop() > 600) {
                $(".bk_hdr").addClass("is-sticky");
            } else {
                $(".bk_hdr").removeClass("is-sticky");
            }
        });
        $(window).bind("pageshow", function (event) {
            if (event.originalEvent.persisted) {
                window.location.reload()
            }
        });

        window.$('#audio-control').click(function(){
            if( window.$("#lndMinVid").prop('muted') ) {
                window.$("#lndMinVid").prop('muted', false);
                window.$(this).addClass('mute');
              // or toggle class, style it with a volume icon sprite, change background-position
            } else {
                window.$("#lndMinVid").prop('muted', true);
                window.$(this).removeClass('mute');
            }
        });

        window.$('.topDropdownMob .dropdown > a').on("click", function (e) {
            // var submenu = $(this);
            // $('.topDropdownMob .dropdown-menu').removeClass('show');
            // submenu.next('.topDropdownMob .dropdown-menu').addClass('show');
            e.stopPropagation();
            $(this).next('.dropdown-menu').toggleClass('show');
        });

        window.$("#vidbutton").click(function() {
            if (window.$("#bgVideo").get(0).paused) {
                window.$("#bgVideo").trigger('play');
                window.$("#vidbutton").addClass('pause');
            } else {
                window.$("#bgVideo").trigger('pause');
                window.$("#vidbutton").removeClass('pause');
            }
        });
        
        //this.getLandingProject();
        //this.getLandingStories();
        if (!this.state.loginSuccess) {
            this.getPromotion();
        }
    }

    getTestimonialShowFlagUpdate = (count) => {
        this.setState({
            testimonials: {flag: count > 0 ? true : false, count: count}
        })
    }


    getUnauthProjectDetails = (slug) => {
        axios({
            method: "get",
            url:
                process.env.REACT_APP_userServiceURL +
                "/unauth/find-project-description-details-by-slug/" +
                slug,
            headers: {"Content-Type": "application/json"},
            withCredentials: true,
        }).then((response) => {
            let res = response.data;
            if (res.status === "200 OK") {
                this.setState({projectDetail: res.body}, () => {
                    if (this.state.projectDetail && this.state.projectDetail.project) {
                        if (this.state.projectDetail.project.assignmentTitle) {
                            document.title = this.state.projectDetail.project.assignmentTitle + ' | New opportunities and projects to explore | WeNaturalists';
                        } else if (this.state.projectDetail.project.title) {
                            document.title = this.state.projectDetail.project.title + ' | New opportunities and projects to explore | WeNaturalists';
                        } else if (this.state.projectDetail.project.sessionTitle) {
                            document.title = this.state.projectDetail.project.sessionTitle + ' | New opportunities and projects to explore | WeNaturalists';
                        } else if (this.state.projectDetail.project.jobTitle) {
                            document.title = this.state.projectDetail.project.jobTitle + ' | New opportunities and projects to explore | WeNaturalists';
                        }
                    }
                });
                window.$("#projectDetails").modal("show");
            }
        }).catch((err) => {
            if (err && err.response) {
                this.setState({
                    notFoundstatusCode: err.response.status,
                    error: {message: err.response.data.message, err: err.response},
                });
            }
            this.setState({
                isLoaded: true,
            });
        });
    };

    getLandingStories = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + "/recommend/unauth/landingpageexplore/",
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.status === 200 && response.data.data) {
                this.setState({
                    stories: response.data.data,
                    mainStory: response.data.data[2]
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getLandingProject = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + "/unauth/landingpageproject",

            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.status === 200) {
                this.setState({opportunities: response.data.body});
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    handleLoginClose = () => {
        this.setState({'loginRequired': false})
        window.$('#loginModal').modal('hide');
    }

    getOptimizedImage(project) {
        if (project.resizedImages && project.resizedImages['300x300'] != null) {
            return project.resizedImages['300x300'];
        }
        return project.coverImage;
    }

    modalOpen = (slug) => {
        this.setState({isModalOpen: true}, () => {
            this.setState({
                slug: '/project/feeds/' + slug
            })
            window.$('#projectDetails').modal('show');
            this.getUnauthProjectDetails(slug);
        })
    }

    openModalClose = () => {
        this.setState({
            slug: ''
        })
        window.$('#projectDetails').modal('hide');
        this.setState({isModalOpen: false}, () => {

        })
    }
    closePromotionModal = (event)=>{
        event.preventDefault();
        window.$("#promotion").modal("hide");
    }
    componentWillUnmount() {
        this.openModalClose();
        this.setState({
            slug: '',
            loginRequired: false,
            isModalOpen: false
        },()=>{
            window.$('#loginModal').modal('hide');
            window.$('#projectDetails').modal('hide');
            window.$("#unauthprojectPopup").modal("hide");
            window.$("#promotion").modal("hide");
        })

    }

    handleApply = (slug) => {
        this.setState({
            slug: slug,
            'loginRequired': true
        },()=>{
            window.$('#loginModal').modal('show');
        })
    }

    signUpRequired=()=>{
        this.setState({'signUpRequired':true})
        window.$('#signupModal').modal('show');
    }

    handleSignUpClose = () => {
        this.setState({'signUpRequired': false})
        window.$('#signupModal').modal('hide');
    }

    handleDetailPage(evt, news_url) {
        evt.preventDefault();
        if (news_url !== undefined && news_url !== null) {
            window.open(news_url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=50,width=1000,height=1000");
        }
    }

    getExploreOptimizedImage(obj,dimension) {
        if (obj.s3Images && obj.s3Images[dimension] != null) {
            return obj.s3Images[dimension];
        }
        return obj.image_url;
    }
    getPromotion = () => {
        axios({
            method: "get",
            url:
                process.env.REACT_APP_userServiceURL +
                "/backend/unauth/getPromotion/" ,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        }).then((response) => {
            if (
                response &&
                response.data &&
                response.data.body &&
                response.status === 200
            ) {
                this.setState(
                    {
                        promotionData: response.data.body,
                    },
                    () => {
                        if(this.state.promotionData && this.state.promotionData.canLanding) {
                            window.$("#promotion").modal("show");
                        }
                    }
                );
            }
        });
    };

    redirectToMyWenat = () => {
        let url = process.env.REACT_APP_myWenatUrl;
        if(process.env.REACT_APP_environment === "uat") {
            url = "https://my.uat.wenat.beegram.net";
        } else if(process.env.REACT_APP_environment === "prod") {
            url = "https://my.wenaturalists.com";
        }
        window.location.href = `${url}`
    }

    render() {
        const {loginSuccess, testimonials} = this.state;
        let noOfDaysPosted = mappingUtils.getNoOfDaysAfterPosted(
            this.state.projectDetail && this.state.projectDetail.dateOfPosting
        );
        let title =
            this.state.projectDetail &&
            this.state.projectDetail.project &&
                this.state.projectDetail.project.title;
        let location =
            this.state.projectDetail &&
            this.state.projectDetail.project &&
                this.state.projectDetail.project.location ;
        let fees =
            (this.state.projectDetail &&
                this.state.projectDetail.project &&
                this.state.projectDetail.project.cost) ;

        let attachments = [];
        if (this.state.projectDetail && this.state.projectDetail.project && this.state.projectDetail.project.attachments && this.state.projectDetail.project.attachments.length > 0) {
            let attachedFiles = this.state.projectDetail.project.attachments;
            attachedFiles.map((data, index) => {
                let value = {
                    name: data.substring(data.lastIndexOf('/') + 1),
                    url: data
                }
                attachments.push(value);

            })
        }
        let showProjectType;
        let projectType = this.state.projectDetail && this.state.projectDetail.participationDetails && this.state.projectDetail.participationDetails.projectType;
        let secondaryEntityType = this.state.projectDetail && this.state.projectDetail.participationDetails &&
            this.state.projectDetail.participationDetails.secondaryEntityType;
        if (secondaryEntityType && projectType && !_.isNull(secondaryEntityType) && !_.isNull(projectType)) {
            if (projectType.toUpperCase() === 'VOLUNTEER') {
                showProjectType = getVolunterProjectName(secondaryEntityType);
            } else {
                showProjectType = projectType;
            }

        } else {
            showProjectType = projectType;
        }

        let role = this.state.projectDetail && this.state.projectDetail.project && (this.state.projectDetail.project.jobRole || this.state.projectDetail.project.assignmentRole);
        let qualifications = this.state.projectDetail && this.state.projectDetail.project && (this.state.projectDetail.project.qualifications || this.state.projectDetail.project.qualificationRequired);
        let typeContent;
        if (this.state.projectDetail && this.state.projectDetail.participationDetails && this.state.projectDetail.participationDetails.secondaryEntityType === 'EVENT') {
            typeContent = "Mementos or Event Kits"
        } else if (this.state.projectDetail && this.state.projectDetail.participationDetails && this.state.projectDetail.participationDetails.secondaryEntityType === 'JOB') {
            typeContent = "Remarks"
        } else if (this.state.projectDetail && this.state.projectDetail.participationDetails && this.state.projectDetail.participationDetails.secondaryEntityType === 'ASSIGNMENT') {
            typeContent = "Certification or Accolades"
        } else if (this.state.projectDetail && this.state.projectDetail.participationDetails && this.state.projectDetail.participationDetails.secondaryEntityType === 'TRAINING') {
            typeContent = "Certification or Accolades"
        }else if (this.state.projectDetail && this.state.projectDetail.participationDetails && this.state.projectDetail.participationDetails.secondaryEntityType === 'FUNDRAISE') {
            typeContent = "Mementos or Event Kits"
        }else if (this.state.projectDetail && this.state.projectDetail.participationDetails && this.state.projectDetail.participationDetails.secondaryEntityType === 'STORYBOOK') {
            typeContent = "Mementos or Event Kits"
        }else if (this.state.projectDetail && this.state.projectDetail.participationDetails && this.state.projectDetail.participationDetails.secondaryEntityType === 'EXPEDITION') {
            typeContent = "Mementos or Event Kits"
        }

        let endDate = ''

        if (this.state.projectDetail && this.state.projectDetail.endDate > 0) {
            endDate = dateUtil.format(new Date(this.state.projectDetail.endDate), "DD MMM YYYY")
        } else {
            endDate = 'NA';
        }

        let linkfiedHtml1 = "<p className=\"pdtlsLink\">" + renderToString(<Linkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
                <a target="blank" href={decoratedHref} key={key}>
                    {decoratedText}
                </a>
            )}>{location && location.address
            ? location.address.replace(/<br\/>/g, '\n').replace(/&nbsp;/g, ' ')
            : ''}</Linkify>).replace(/&nbsp;/g, ' ')
            .replace(/(\r\n|\r|\n)/g, '<br>')
            .replace(/(\\n)/g, '<br>') + "</p>"
        if (loginSuccess) {
            return <Home creditUserFlag={this.props.location?.state?.creditUserFlag} />
        } else {
            return <div className="landing staticPage">
                <HeaderLanding/>
                              

                <div className="dgcontainer">
                    <div className="bklnbansec">
                        <div className="banvideobx">
                            <video autoPlay loop muted playsInline id='bgVideo'>
                                {/* <source src="https://cdn.dscovr.com/images/original-video.mp4" type="video/mp4"/>
                                <source src="https://cdn.dscovr.com/images/landingNewvideo.mp4" type="video/mp4"/> */}
                                <source src="https://cdn.dscovr.com/images/landingVideoSep22.mp4" type="video/mp4" />
                            </video>
                            {/* <button id="vidbutton" className='pause'></button> */}
                        </div>
                        <div className="bkbancontbx">
                            <div className="container-fluid">
                                <div className="mob_displyLgo">
                                    <a href="/"><img src="https://cdn.dscovr.com/images/logoWeNaturalists.svg" width={'300'} alt="WeNaturalists"/></a>
                                </div>
                                <div className="bancentrbx">                                        
                                    <h1>Digital Solutions for Professionals and Organizations Working in Climate Action, SDGs and ESG</h1>
                                    <a href="/signup" className="sgnupdomrbtn">Sign Up</a><br/>
                                    <a href="javascript:void(0)" onClick={(e)=>this.handleApply('/')} className="seehwbtn">
                                        Already a member? <span>Login</span></a>
                                    <h2>Say goodbye to the hassles and high costs of</h2>
                                    <ul>
                                        <li>Managing projects</li>
                                        <li>Managing Partners</li>
                                        <li>Finding partners and teams</li>
                                        <li>Recording on-ground activities</li>
                                        <li>Fundraise</li>
                                        <li>Access to jobs and learning</li>
                                    </ul>
                                    {/* <div className='bancentExtTxt'>
                                        <span>Find solutions to manage Communication, Projects, Community and Donors</span>
                                        <span>Opportunities to Earn, Learn and Collaborate</span>
                                    </div> */}
                                </div>                                
                            </div>
                        </div>
                    </div>
                    
                    <div className='lndMyWeNatWrap'>
                        <div className='container'>
                            <div className='lndMyWeNatrow sectionLndAll'>
                                <div class="title">
                                    <h2>Create your own <br/><a href={"javascript:void(0)"} onClick={() => this.redirectToMyWenat()}><span>my</span> <img src="https://cdn.dscovr.com/images/logoWeNaturalists.svg" alt="" /></a></h2>
                                    <h5>A license to create your own community</h5>
                                </div>
                                <p>myWeNaturalists account is a license to create your own community with all the features of WeNaturalists. All your members, activities, 
                                    projects, records, micro communities, groups, posts and more remain exclusively with you, and avoids anyone accessing it from outside.</p>
                                <p>Any professional or an organization looking for a exclusive platform for building a community can opt for a myWeNaturalists account.</p>
                                <div className='support'>Write to us at <a href='mailto:support@WeNaturalists.com'>support@WeNaturalists.com</a> for more details.</div>
                            </div>
                        </div>
                    </div>

                    <div className='sectionLndAll newVideoAdditionWrap'>
                        <div className='container'>
                            <div className='title text-center mb-4'>
                                <h2>Our Journey</h2>
                            </div>
                            <div className='videoWrap'>
                                <ReactPlayer
                                    url="https://youtu.be/HbcfmkvsqzQ?feature=shared"
                                    //playing={true}
                                    playsinline
                                    //muted
                                    loop
                                    //controls
                                    width={'100%'}
                                    height={'100%'}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="lndwrapcontmain">
                        <BelongHereSection />
                        <div className='container'>
                           <InspiringStorySection />
                           {testimonials?.flag && 
                                <section className="dgLandTestoWrap landCommonSec">
                                    <div className="container">
                                        <div className="row align-items-center">
                                            <div className="col-lg-4">
                                                <div className="secTitle">
                                                    <h2>Experiences on WeNaturalists</h2>
                                                    <p>WeNaturalists provides solutions to improve your efficiencies, reduce costs and improve income</p>                                        
                                                </div>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="dgLandTestoCard">
                                                    <TestimonialItem getTestimonialShowFlagUpdate={this.getTestimonialShowFlagUpdate} isLandingPage={true} />
                                                </div>
                                            </div>
                                        </div>
                                        {testimonials?.count > 4 && 
                                            <div className='btnblock'>
                                                <Link class="btn morebtnsm" to="/show-all/testimonial">View All</Link>
                                            </div>
                                        }
                                    </div>
                                </section>
                            }
                           <WeNatSolutionsSection />
                           <TrendingContentSection />
                        </div>
                    </div>
                    <Footer/>
                </div>

                <LeftPanelUnauth signUpRequired={this.signUpRequired}/>
                
                {this.state.isModalOpen === true ?
                    <div
                        id="projectDetails"
                        className="modal fade dgpopup authLoginModal"
                        data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="projectdescwrap">
                                        <button className="close" onClick={this.openModalClose}><i className="iCross"></i></button>
                                        <div className="projdestopbar">
                                            <h1>
                                                {showProjectType}
                                            </h1>
                                            <ul>
                                                {this.state.projectDetail &&
                                                this.state.projectDetail.demolished === false && (
                                                    <li className="posted">
                                                        {noOfDaysPosted === 0 || noOfDaysPosted === "0" ? (
                                                            <span>Posted Today</span>
                                                        ) : (
                                                            <span>
                                                                Posted {noOfDaysPosted}
                                                                {noOfDaysPosted < 2 ? "d" : "d"} ago
                                                            </span>
                                                        )}
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                        <div className="projdesheader">
                                            <div className="row">
                                                <div className="col-lg-4 jobsblk">
                                                    <span>Title</span>
                                                    <h4>{unescape(title)}</h4>
                                                    <p className="addRss">
                                                        <i className="iLocation"></i>
                                                        <span>
                        {location && location.city},{" "}
                                                            {location && location.state},{" "}
                                                            {location && location.country}
                        </span>

                                                    </p>
                                                    {this.state.projectDetail &&
                                                    this.state.projectDetail.project &&
                                                    this.state.projectDetail.project.isDisclosed ==
                                                    false &&
                                                    fees > 0 && (
                                                        <div className="price">
                                                            <i className="iWallet"></i>{" "}
                                                            {this.state.projectDetail.project.currency}{" "}
                                                            {nFormatter(fees, 2)}{" "}
                                                            {!_.isNull(
                                                                this.state.projectDetail.project.packageType
                                                            ) &&
                                                            !_.isUndefined(
                                                                this.state.projectDetail.project.packageType
                                                            ) &&
                                                            this.state.projectDetail.project.packageType.toLowerCase() !==
                                                            "custom" &&
                                                            this.state.projectDetail.project.packageType}
                                                            <span>
                            {this.state.projectDetail.project
                                .isNegotiable && "(Negotiable)"}
                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-lg-4 recruiter">
                                                    <span>Creator</span>
                                                    <div className="recruitblk">
                                                        {this.state.projectDetail &&
                                                        this.state.projectDetail.creatorName && (
                                                            <div
                                                                className="recruit"
                                                                style={{cursor: 'pointer'}} onClick={(e)=> {e.preventDefault();redirectToProfilePage(this.state.projectDetail.customUrl,this.state.projectDetail.partyType)}}>
                                                                <figure
                                                                    className="complogo"
                                                                    style={{cursor: 'pointer'}}
                                                                    onClick={(e)=> {e.preventDefault();redirectToProfilePage(this.state.projectDetail.customUrl,this.state.projectDetail.partyType)}}
                                                                >
                                                                    <img
                                                                        src={
                                                                            !_.isUndefined(
                                                                                this.state.projectDetail &&
                                                                                this.state.projectDetail
                                                                                    .imageUrl
                                                                            ) &&
                                                                            !_.isNull(
                                                                                this.state.projectDetail &&
                                                                                this.state.projectDetail
                                                                                    .imageUrl
                                                                            )
                                                                                ? getCDNUrl(
                                                                                this.state.projectDetail &&
                                                                                this.state.projectDetail
                                                                                    .imageUrl
                                                                                )
                                                                                : this.state.projectDetail &&
                                                                                this.state.projectDetail.userType ==
                                                                                "INDIVIDUAL"
                                                                                ? "https://cdn.dscovr.com/images/users1.png"
                                                                                : "https://cdn.dscovr.com/images/DefaultBusiness.png"
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </figure>
                                                                {this.state.projectDetail &&
                                                                this.state.projectDetail.creatorName}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {this.state.projectDetail &&
                                                    this.state.projectDetail.project &&
                                                    this.state.projectDetail.project.companyName &&
                                                    !_.isNull(
                                                        this.state.projectDetail.project.companyName
                                                    ) &&
                                                    this.state.projectDetail.project.companyName !==
                                                    "null" && (
                                                        <>
                                                            <span>Organization</span>
                                                            <div className="recruit">
                                                                {/*<figure className="complogo">
                                    <img src={coverImage} alt=""/>
                                </figure>*/}
                                                                <span>
                                {unescape(
                                    this.state.projectDetail.project.companyName
                                )}
                            </span>
                                                            </div>
                                                        </>
                                                    )}
                                                    {this.state.projectDetail &&
                                                    this.state.projectDetail.project &&
                                                    this.state.projectDetail.project.websiteLink &&
                                                    this.state.projectDetail.project.websiteLink[0] !==
                                                    "" && (
                                                        <p>
                                                            <a
                                                                onClick={(event) =>
                                                                    window.open(
                                                                        this.state.projectDetail.project
                                                                            .websiteLink[0]
                                                                            ? mappingUtils.sanitize(
                                                                            this.state.projectDetail.project
                                                                                .websiteLink[0]
                                                                            )
                                                                            : mappingUtils.sanitize(
                                                                            this.state.projectDetail.project
                                                                                .websiteLink[0]
                                                                            ),
                                                                        "_blank"
                                                                    )
                                                                }
                                                                href="javascript:void(0)"
                                                            >
                                                                <i className="iGlobe"/> Website
                                                            </a>
                                                        </p>
                                                    )}
                                                </div>
                                                {this.state.projectDetail &&
                                                this.state.projectDetail.isOffLine === false &&
                                                this.state.projectDetail.demolished === false && (
                                                    <div className="col-lg-4 opening">
                                                        {(this.state.projectDetail.participationDetails.secondaryEntityType !== "FUNDRAISE" || (this.state.projectDetail.participationDetails.secondaryEntityType === "FUNDRAISE" && this.state.projectDetail.lastDateOfApplication !== 0)) &&
                                                            <>
                                                                <span>Application</span>
                                                                <p>
                                                                    Last date:{" "}
                                                                    {dateUtil.format(
                                                                        new Date(
                                                                            this.state.projectDetail.lastDateOfApplication
                                                                        ),
                                                                        "DD MMM YYYY"
                                                                    )}
                                                                </p>
                                                                {this.state.projectDetail &&
                                                                    this.state.projectDetail.noOfOpenings &&
                                                                    this.state.projectDetail.noOfOpenings > 0 && <p> Openings:{" "}{this.state.projectDetail.noOfOpenings}</p>
                                                                }
                                                            </>
                                                        }
                                                        <div className="buttblk">
                                                            <a
                                                                className="btn btn-primary"
                                                                href="javascript:void(0)"
                                                                onClick={(e)=>this.handleApply('/project/feeds/' + this.state.projectDetail.slug)}
                                                            >
                                                                Apply
                                                            </a>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="projdesbody">
                                            <div className="projdesbodyinn">
                                                <div className="largetext">
                                                    <h5>Brief Description</h5>
                                                    <p><Linkify
                                                        componentDecorator={(decoratedHref, decoratedText, key) => (
                                                            <a target="blank" href={decoratedHref} key={key}>
                                                                {decoratedText}
                                                            </a>
                                                        )}>{this.state.projectDetail && this.state.projectDetail.project && this.state.projectDetail.project.shortBrief && !_.isNull(this.state.projectDetail.project.shortBrief) && this.state.projectDetail.project.shortBrief.split("\n").map(brief => (<>{convertUnicode(brief)}<br/></>))}</Linkify>
                                                    </p>
                                                </div>
                                                {this.state.projectDetail && this.state.projectDetail.project && this.state.projectDetail.project.description && (
                                                    <>
                                                        <h5>Detailed Description</h5>
                                                        {/* <Linkify
                                                            componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                <a target="blank" href={decoratedHref} key={key}>
                                                                    {decoratedText}
                                                                </a>
                                                            )}>
                                                            <p>{this.state.projectDetail.project.description && this.state.projectDetail.project.description.split("\n").map(descrip => (<>{convertUnicode(descrip)}<br/></>))}</p>
                                                        </Linkify> */}
                                                        <div className="projDetailsDesc">
                                                            <div className="editor-text" dangerouslySetInnerHTML={{__html: this.state.projectDetail.project.description}}/>
                                                        </div>
                                                    </>
                                                )}

                                                <div className="pdescattachwrap">
                                                    {attachments &&
                                                    attachments.map((value) => {
                                                        //let file = JSON.parse(unescapeJs(value));
                                                        return (
                                                            <a href="javascript:void(0)" className="pdescattachfile"
                                                                onClick={e => {
                                                                    isWebView() ? postMsg("download", value.url)
                                                                        : this.download_file_pdf(e, value.url);
                                                                }} style={{cursor:"default"}}>
                                    <span>
                                        <i className="iDownloadFile1"/>
                                        {value.name && value.name.substring(value.name.indexOf("-") + 1)}
                                    </span>
                                                            </a>
                                                        );
                                                    })}
                                                </div>

                                                {role && role.trim() != "type text" && (
                                                    <>
                                                        <h5>Roles and Responsibilities</h5>
                                                        {/* <p dangerouslySetInnerHTML={{
                                __html: role
                                    ? role
                                        .replace(/&nbsp;/g, ' ')
                                        .replace(/(\r\n|\r|\n)/g, '<br>')
                                    : ''
                            }}/> */}
                                                        <Linkify
                                                            componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                <a target="blank" href={decoratedHref} key={key}>
                                                                    {decoratedText}
                                                                </a>
                                                            )}>
                                                            <p>{role && role.split("\n").map(role => (<>{convertUnicode(role)}<br/></>))}</p>
                                                        </Linkify>

                                                    </>
                                                )}

                                                {qualifications && qualifications.length > 0 && (
                                                    <>
                                                        <h5>Qualification</h5>
                                                        <ul className="ulstyles">
                                                            {qualifications &&
                                                            qualifications.map((qual) => {
                                                                return <li><Linkify
                                                                    componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                        <a target="blank" href={decoratedHref}
                                                                            key={key}>
                                                                            {decoratedText}
                                                                        </a>
                                                                    )}>{qual && qual.split("\n").map(qual => (<>{convertUnicode(qual)}<br/></>))}</Linkify>
                                                                </li>

                                                            })}
                                                        </ul>
                                                    </>
                                                )}

                                                <div className="pdincluexclu">
                                                    <div className="row">
                                                        {this.state.projectDetail && this.state.projectDetail.project && this.state.projectDetail.project.inclusions && this.state.projectDetail.project.inclusions.length > 0 && this.state.projectDetail.project.inclusions[0] != "" && (
                                                            <div className="col-md-6">
                                                                <h5>Inclusion</h5>
                                                                <Linkify
                                                                    componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                        <a target="blank" href={decoratedHref}
                                                                            key={key}>
                                                                            {decoratedText}
                                                                        </a>
                                                                    )}>{this.state.projectDetail.project.inclusions && this.state.projectDetail.project.inclusions.map((incl) =>
                                                                    <p>{incl && incl.split("\n").map(incl => (<>{convertUnicode(incl)}<br/></>))}</p>)}</Linkify>

                                                            </div>
                                                        )}
                                                        {this.state.projectDetail && this.state.projectDetail.project && this.state.projectDetail.project.exclusions && this.state.projectDetail.project.exclusions.length > 0 && this.state.projectDetail.project.exclusions[0] != "" && (
                                                            <div className="col-md-6">
                                                                <h5>Exclusion</h5>
                                                                <Linkify
                                                                    componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                        <a target="blank" href={decoratedHref}
                                                                            key={key}>
                                                                            {decoratedText}
                                                                        </a>
                                                                    )}>{this.state.projectDetail.project.exclusions && this.state.projectDetail.project.exclusions.map((excl) =>
                                                                    <p>{excl && excl.split("\n").map(excl => (<>{convertUnicode(excl)}<br/></>))}</p>)}</Linkify>

                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                {this.state.projectDetail && this.state.projectDetail.project && this.state.projectDetail.project.endTakeAway && (
                                                    <>
                                                        <h5>
                                                            {typeContent}
                                                            <span>(Received by participant post completion)</span>
                                                        </h5>
                                                        <Linkify
                                                            componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                <a target="blank" href={decoratedHref} key={key}>
                                                                    {decoratedText}
                                                                </a>
                                                            )}>
                                                            <p>{this.state.projectDetail.project.endTakeAway && this.state.projectDetail.project.endTakeAway.split("\n").map(endTakeAway => (<>{convertUnicode(endTakeAway)}<br/></>))}</p>
                                                        </Linkify>


                                                    </>
                                                )}
                                                {this.state.projectDetail && this.state.projectDetail.project && this.state.projectDetail.project.mediaAttachments && this.state.projectDetail.project.mediaAttachments.length > 0 && this.state.projectDetail.project.mediaAttachments[0] !== "" && (
                                                    <>
                                                        <h5>Media Coverage</h5>
                                                        <ul>
                                                            {this.state.projectDetail.project.mediaAttachments &&
                                                            this.state.projectDetail.project.mediaAttachments.map((media) => {
                                                                return <li className="pdtlsLink"><Linkify
                                                                    componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                        <a target="blank" href={decoratedHref}
                                                                            key={key}>
                                                                            {decoratedText}
                                                                        </a>
                                                                    )}>{media && media.split("\n").map(media => (<>{convertUnicode(media)}<br/></>))}</Linkify>
                                                                </li>

                                                            })}
                                                        </ul>
                                                    </>
                                                )}

                                                {this.state.projectDetail && this.state.projectDetail.project && this.state.projectDetail.project.specialization &&
                                                this.state.projectDetail.project.skills &&
                                                (this.state.projectDetail.project.skills.length > 0 ||
                                                    this.state.projectDetail.project.specialization.length > 0) && (
                                                    <div className="specialskills">
                                                        <h5>Skills and Specialization</h5>
                                                        <div className="specialskillsblk">
                                                            {this.state.projectDetail.project.specialization && this.state.projectDetail.project.specialization.length > 0 && (
                                                                <div className="spsktags">
                                                                    {" "}
                                                                    {this.state.projectDetail.project.specialization &&
                                                                    this.state.projectDetail.project.specialization.map((sp) =>
                                                                        <span>{convertUnicode(sp)}</span>)}{" "}
                                                                </div>
                                                            )}
                                                            {this.state.projectDetail && this.state.projectDetail.project && this.state.projectDetail.project.skills && this.state.projectDetail.project.skills.length > 0 && (
                                                                <div className="spsktags">
                                                                    {" "}
                                                                    {this.state.projectDetail.project.skills &&
                                                                    this.state.projectDetail.project.skills.map((skill) => (
                                                                        <span>{unescape(skill)}</span>
                                                                    ))}{" "}
                                                                </div>
                                                            )}

                                                        </div>
                                                    </div>
                                                )}
                                                <div className="pdincluexclu locaduration">
                                                    {location && location.address &&
                                                    <>
                                                        <h5>Detailed Address </h5>
                                                        <p className="addRss"><Linkify
                                                            componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                <a target="blank" href={decoratedHref} key={key}>
                                                                    {decoratedText}
                                                                </a>
                                                            )}><span dangerouslySetInnerHTML={{
                                                            __html: linkfiedHtml1
                                                        }}/></Linkify></p>
                                                    </>}
                                                </div>
                                                <div className="pdincluexclu locaduration">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <h5>Duration</h5>
                                                            <ul>
                                                                <li>
                                                                    <span>Start Date</span> {dateUtil.format(new Date(this.state.projectDetail && this.state.projectDetail.startDate), "DD MMM YYYY")}
                                                                </li>
                                                                {endDate !== "" &&
                                                                <li>
                                                                    <span>End Date</span> {endDate}
                                                                </li>
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <>
                    </>
                }
                {this.state.loginRequired === true ?
                    <AuthModalComponent handleLoginClose={this.handleLoginClose} isLandingPage={true}
                                        pathname={this.state.slug} history={this.props.history}/> : null}
                {this.state.signUpRequired === true ? <SignUpModal  handleSignUpClose={this.handleSignUpClose} history={this.props.history}/> : null}
                
                {this.state.promotionData && this.state.promotionData.coverImageUrl && this.state.promotionData.coverImageUrl &&
                <div
                    id="promotion"
                    className="modal fade dgpopup"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="promotionPopWrap">
                                    <button type="button" className="close" data-dismiss="modal" onClick={this.closePromotionModal}
                                            aria-label="Close"><span
                                        aria-hidden="true">&times;</span></button>
                                    <a  href={this.state.promotionData.link}><img src={
                                        this.state.promotionData &&
                                        this.state.promotionData.coverImageUrl
                                        && this.state.promotionData.coverImageUrl
                                    } alt="" /></a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>
        }

    }
}

export default Landing
